module.exports = __webpack_public_path__ + "static/images/chevron-right.68f56571c6b21f9ab1bbe650b5c5a44f.svg";